import { render, staticRenderFns } from "./CurrencyRates.vue?vue&type=template&id=5bf7aebc&scoped=true"
import script from "./CurrencyRates.vue?vue&type=script&lang=js"
export * from "./CurrencyRates.vue?vue&type=script&lang=js"
import style0 from "./CurrencyRates.vue?vue&type=style&index=0&id=5bf7aebc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf7aebc",
  null
  
)

export default component.exports